export interface IAuthModel {
    policies: Array<string>;
    contactID?: number;
    contactRef?: string;
    enableTasksOnIssuesOnly?: Boolean;
}

// MAP
export const CAMSMap_CanSeeMaint = "CAMSMap_CanSeeMaint";
export const CAMSMap_CanSeeMyMaint = "CAMSMap_CanSeeMyMaint";
export const CAMSMap_CanSeeMaintUnvalidated = "CAMSMap_CanSeeMaintUnvalidated";
export const CAMSMap_CanSeeInfra = "CAMSMap_CanSeeInfra";
export const CAMSMap_CanSeeInfraHistoric = "CAMSMap_CanSeeInfraHistoric";
export const CAMSMap_CanSeeInfraUnvalidated = "CAMSMap_CanSeeInfraUnvalidated";
export const CAMSMap_CanSeeRoute = "CAMSMap_CanSeeRoute";
export const CAMSMap_CanEditRoute = "CAMSMap_CanEditRoute";
export const CAMSMap_CanSeeLand = "CAMSMap_CanSeeLand";
export const CAMSMap_CanEditLand = "CAMSMap_CanEditLand";
export const CAMSMap_CanSeeMaintRejected = "CAMSMap_CanSeeMaintRejected";
export const CAMSMap_CanDeleteInfraHistoric = "CAMSMap_CanDeleteInfraHistoric";
export const CAMSMap_CanSeeLegalRoute = "CAMSMap_CanSeeLegalRoute";
export const CAMSMap_CanSeeLegalFeature = "CAMSMap_CanSeeLegalFeature";


// REPORT AN ISSUE
export const CAMSReportAnIssue = "CAMSReportAnIssue";
export const CAMSReportAnIssue_CanCreateNewIssue = "CAMSReportAnIssue_CanCreateNewIssue";
export const CAMSReportAnIssue_CanCreateNewValidatedIssue = "CAMSReportAnIssue_CanCreateNewValidatedIssue";
export const CAMSReportAnIssue_CanCreateNewIssueOnBehalfOf = "CAMSReportAnIssue_CanCreateNewIssueOnBehalfOf";
export const CAMSReportAnIssue_CanViewAllIssues = "CAMSReportAnIssue_CanViewAllIssues";
export const CAMSReportAnIssues_CanAssignIssueToUser = "CAMSReportAnIssues_CanAssignIssueToUser";
export const CAMSReportAnIssue_CanCreateNewValidatedComment = "CAMSReportAnIssue_CanCreateNewValidatedComment";

// OFFICER MAP
export const CAMSOfficerMap = "CAMSOfficerMap";

// MY TASKS
export const CAMSMyTasks = "CAMSMyTasks";

// TASK MANAGEMENT
export const CAMSTaskManagement = "CAMSTaskManagement";
export const CAMSTaskManagement_CanViewUnassignedTasks = "CAMSTaskManagement_CanViewUnassignedTasks";
export const CAMSTaskManagement_CanViewAssignedTasks = "CAMSTaskManagement_CanViewAssignedTasks";
export const CAMSTaskManagement_CanViewCompletedAwaitingSignOffTasks = "CAMSTaskManagement_CanViewCompletedAwaitingSignOffTasks";
export const CAMSTaskManagement_CanViewUnassignedGroupTasks = "CAMSTaskManagement_CanViewUnassignedGroupTasks";
export const CAMSTaskManagement_CanViewAssignedGroupTasks = "CAMSTaskManagement_CanViewAssignedGroupTasks";
export const CAMSTaskManagement_CanViewCompletedGroupsAwaitingSignOffTasks = "CAMSTaskManagement_CanViewCompletedGroupsAwaitingSignOffTasks";
export const CAMSTaskManagement_CanViewRejectedTasks = "CAMSTaskManagement_CanViewRejectedTasks";
export const CAMSTaskManagement_CanViewPoolTasks = "CAMSTaskManagement_CanViewPoolTasks";
export const CAMSTaskManagement_CanViewCompletedAwaitingInspectionTasks = "CAMSTaskManagement_CanViewCompletedAwaitingInspectionTasks";
export const CAMSTaskManagement_CanViewRejectedGroupTasks = "CAMSTaskManagement_CanViewRejectedGroupTasks";
export const CAMSTaskManagement_CanViewAdoptAPathTasks = "CAMSTaskManagement_CanViewAdoptAPathTasks";
export const CAMSTaskManagement_CanViewCompletedGroupAwaitingInspectionTasks = "CAMSTaskManagement_CanViewCompletedGroupAwaitingInspectionTasks";
export const CAMSTaskManagement_CanViewOrphanTasks = "CAMSTaskManagement_CanViewOrphanTasks";
export const CAMSTaskManagement_CanViewAllTasks = "CAMSTaskManagement_CanViewAllTasks";
export const CAMSTaskManagement_CanViewAllTaskGroups = "CAMSTaskManagement_CanViewAllTaskGroups";

// SUBMISSIONS
export const CAMSSubmission = "CAMSSubmission";

// CONSULTATIONS
export const CAMSConsultations = "CAMSConsultations";

// LEGAL
export const CAMSLegal = "CAMSLegal";

// LAND
export const CAMSLand = "CAMSLand";

//ADMIN
export const CAMSAdmin_CanUserAdmin = "CAMSAdmin_CanUserAdmin";

// ACTIVITY
export const CAMSActivity = "CAMSActivity";

// CONTACTS
export const CAMSContacts = "CAMSContacts";
export const CAMSConacts_CanEdit = "CAMSConacts_CanEdit";

// SEARCH
export const CAMSSearchBasicPolicy = "CAMSSearchBasicPolicy";

// ANNOTATION
export const CAMSAnnotation = "CAMSAnnotation";

// TRO
export const CAMSTRO = "CAMSTRO";

